export default __webpack_public_path__ + "static/media/16_2.a197bc35.jpg";